import React from "react";
const Education = () => {
    return (<>
        <div id="edu" className="Education1">
            <h1>Education</h1>
            <div className="Education2">
                <div className="Education" data-aos="fade-up" data-aos-anchor-placement="bottom center">
                    <></>
                    <img className="eduinvert" src="education.png" />
                    <span className="year">2020-2024</span>
                    <span>B.tech in Computer Engineering</span>
                    <span>Tatyasaheb Kore Institute of Engineering and Technology,Warnanagar</span>
                </div>
                <div className="Education" data-aos="fade-up" data-aos-anchor-placement="bottom center">
                    <img className="eduinvert" src="education.png" />
                    <span className="year">2018-2020</span>
                    <span>Std 11-12 (Science)</span>
                    <span>Yashwantrao Chavan College of Science Karad</span>
                </div>
                <div className="Education" data-aos="fade-up" data-aos-anchor-placement="bottom center">
                    <img className="eduinvert" src="education.png" />
                    <span className="year">2008-2018</span>
                    <span>Std 1-10</span>
                    <span>Shri.Chhatrapati Vidyamandir Tarale</span>
                </div>
                <h1>Experience</h1>
                <div className="Education" data-aos="fade-up" data-aos-anchor-placement="bottom center">
                    <img className="eduinvert" src="experience.png" />
                    <span className="year">May 2023 - June 2023</span>
                    <span> Reactjs Developer intern</span>
                    <span>DreamLegal </span>
                    <span>
                        <p>
                            •
                            Developed a dynamic mobile repairing website using React.js and Material-UI,
                            integrating APIs for displaying model, brand, and problem data based on user
                            selections</p>
                        <p> • Implemented e-commerce functionality, including a product catalog and
                            shopping cart, using Redux for state management.
                        </p>

                    </span>

                </div>
                <div className="Education" data-aos="fade-up" data-aos-anchor-placement="bottom center">
                    <img className="eduinvert" src="experience.png" />
                    <span className="year">June 2023 - July 2023</span>
                    <span>Web developer intern</span>
                    <span>SKAYKA PVT LTD </span>
                    <span>
                        <p>
                            •
                            Developed responsive websites using HTML, CSS, and JavaScript.</p>
                        <p> • Created two websites focusing on HTML and CSS, showcasing design and
                            development skills.
                        </p>
                        <p> • Redesigned sections of the website to ensure a more attractive and user friendly
                            experience.
                        </p>
                    </span>

                </div>
            </div>
        </div>
    </>)
}
export default Education